import styled, { css } from 'styled-components';
import { NAVIGATION_HEIGHT } from '../../../../navigation/constants/navigation-css-variables';
import { NAVIGATION_ITEMS_MAX_WIDTH } from '../../../../navigation/constants/navigation-items-width';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
import { NavigationDividerElement } from '../../NavigationDivider/styles/navigation-divider.styled';
const NAVIGATION_ACTION_SHEET_MAX_WIDTH = 290;
export const navigationActionSheetContainerStyles = ({ theme, $isActive, }) => css `
	z-index: ${theme.zIndex.popUp};
	position: fixed;
	inset: var(${NAVIGATION_HEIGHT}) 0 0 0;
	display: ${$isActive ? 'flex' : 'none'};
	flex-direction: column;

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		position: absolute;
		height: unset;
		left: unset;
		bottom: unset;
		right: ${pxToRem(theme.spacing['300'])};
		width: 100%;
		max-width: ${pxToRem(NAVIGATION_ACTION_SHEET_MAX_WIDTH)};
		box-shadow: ${pxToRem(theme.boxShadow.popover.x)} ${pxToRem(theme.boxShadow.popover.y)}
			${pxToRem(theme.boxShadow.popover.blur)} ${pxToRem(theme.boxShadow.popover.spread)}
			${theme.boxShadow.popover.color};
		border-bottom-left-radius: ${pxToRem(theme.borderRadius.m)};
		border-bottom-right-radius: ${pxToRem(theme.borderRadius.m)};
	}
`;
export const NavigationActionSheetContainer = styled.div `
	${navigationActionSheetContainerStyles}
`;
export const navigationActionSheetInnerContainerStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: ${pxToRem(theme.spacing['400'])} ${pxToRem(theme.spacing['300'])};
	overflow-y: auto;
	background-color: ${theme.colors.blanc.bgMainNavigation};
	border-bottom-left-radius: ${pxToRem(theme.borderRadius.m)};
	border-bottom-right-radius: ${pxToRem(theme.borderRadius.m)};

	${NavigationDividerElement} {
		margin: ${pxToRem(theme.spacing['100'])} auto;
		width: 100%;
		max-width: ${pxToRem(NAVIGATION_ITEMS_MAX_WIDTH)};
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		padding: ${pxToRem(theme.spacing['400'])};
		width: 100%;
		border: none;

		${NavigationDividerElement} {
			margin: ${pxToRem(theme.spacing['300'])} 0;
		}
	}
`;
export const NavigationActionSheetInnerContainer = styled.div `
	${navigationActionSheetInnerContainerStyles}
`;
